import { encode } from 'html-entities';

export const encodeHtml = (input: string = '') => {
  const output = encode(input).replace(/&Tab;/g, '');
  return output;
};
